"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.changeNotificationIsRead = void 0;
const changeNotificationIsRead = (notifications) => {
    const keys = Object.keys(notifications);
    keys.forEach((el) => {
        notifications[el].isRead = true;
    });
    return notifications;
};
exports.changeNotificationIsRead = changeNotificationIsRead;
//# sourceMappingURL=utils.js.map